
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer-tools/api-guide",
      function () {
        return require("private-next-pages/developer-tools/api-guide.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer-tools/api-guide"])
      });
    }
  